<ng-container *ngFor="let story of stories">
  <div class="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-16 p-4 md:p-16 rounded-[48px] mx-4 md:w-10/12 md:mx-auto mb-16" [ngClass]="{'bg-qo-qomeet/20 dark:bg-qo-qomeetDark/10': theme === 'qomeet', 'bg-qo-qoezion/20 dark:bg-qo-qoezionDark/10': theme === 'qoezion', 'bg-qo-primary-200/20': theme === 'primary'}">
    <picture *ngIf="story?.webp_photo_url">
      <source [srcset]="story?.webp_photo_url" type="image/webp">
      <source [srcset]="story?.photo_url" type="image/jpg">
      <img class="max-h-80 rounded-3xl sm:rounded-6xl" [src]="story?.photo_url" alt="" />
    </picture>
    <img *ngIf="!story?.webp_photo_url" class="max-h-80 rounded-3xl sm:rounded-6xl" [src]="story?.photo_url" alt="" />
    <div class="flex flex-col items-start max-w-[720px]">
      <p class="text-2xl text-qo-color4 mb-6 font-medium whitespace-pre-line">« {{story?.description}} »</p>
      <a *ngIf="story.action_url" matRipple class="qo-MainRoundedBtn mb-6" [routerLink]="[story!.action_url]" i18n>Lire le reportage</a>
      <div class="flex flex-col md:flex-row items-start md:items-center order-first md:order-last mb-6 md:mb-0 gap-8">
        <picture>
          <source [srcset]="story?.logo_url" media="(prefers-color-scheme: light)">
          <source [srcset]="story?.dark_logo_url" media="(prefers-color-scheme: dark)">
          <img class="order-last md:order-first max-h-24 w-40" [src]="story?.logo_url" alt="" />
        </picture>
        <div>
          <p class="font-bold">{{story?.customer_name}}</p>
          <p>{{story?.customer_role}}</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>